var _rect, _g, _rect2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviewedRegistryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3560_28477",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3560_28477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 11.3846C11.175 11.3846 10.4688 11.0909 9.88125 10.5034C9.29375 9.91586 9 9.20961 9 8.38461C9 7.55959 9.29375 6.85333 9.88125 6.26583C10.4688 5.67833 11.175 5.38458 12 5.38458C12.825 5.38458 13.5313 5.67833 14.1188 6.26583C14.7063 6.85333 15 7.55959 15 8.38461C15 9.20961 14.7063 9.91586 14.1188 10.5034C13.5313 11.0909 12.825 11.3846 12 11.3846ZM5 18.6154V16.9692C5 16.5564 5.12019 16.1702 5.36058 15.8106C5.60096 15.4509 5.92436 15.1718 6.33078 14.9731C7.27436 14.5205 8.21858 14.1811 9.16345 13.9548C10.1083 13.7285 11.0539 13.6154 12 13.6154C12.9461 13.6154 13.8917 13.7285 14.8365 13.9548C15.7814 14.1811 16.7256 14.5205 17.6692 14.9731C18.0756 15.1718 18.399 15.4509 18.6394 15.8106C18.8798 16.1702 19 16.5564 19 16.9692V18.6154H5ZM6 17.6154H18V16.9692C18 16.7474 17.9285 16.5391 17.7856 16.3442C17.6426 16.1493 17.4449 15.9846 17.1923 15.85C16.3692 15.4513 15.5206 15.1458 14.6464 14.9336C13.7722 14.7215 12.8901 14.6154 12 14.6154C11.1099 14.6154 10.2278 14.7215 9.3536 14.9336C8.4794 15.1458 7.63077 15.4513 6.8077 15.85C6.55513 15.9846 6.35737 16.1493 6.21442 16.3442C6.07148 16.5391 6 16.7474 6 16.9692V17.6154ZM12 10.3846C12.55 10.3846 13.0208 10.1888 13.4125 9.79711C13.8042 9.40544 14 8.93461 14 8.38461C14 7.83461 13.8042 7.36378 13.4125 6.97211C13.0208 6.58044 12.55 6.38461 12 6.38461C11.45 6.38461 10.9792 6.58044 10.5875 6.97211C10.1958 7.36378 10 7.83461 10 8.38461C10 8.93461 10.1958 9.40544 10.5875 9.79711C10.9792 10.1888 11.45 10.3846 12 10.3846Z",
    fill: "#15B79E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3560_28477",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 2,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 2,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3560_28477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9056 14.4231L29.3191 10.0304L28.8335 9.54477L24.9056 13.4519L23.1347 11.7019L22.6491 12.1875L24.9056 14.4231ZM26.0029 19.1666C25.0213 19.1666 24.0949 18.9803 23.2235 18.6075C22.3522 18.2347 21.5893 17.7214 20.9347 17.0675C20.2802 16.4136 19.7663 15.6514 19.3933 14.7808C19.0201 13.9104 18.8335 12.9844 18.8335 12.0027C18.8335 11.0073 19.0199 10.0773 19.3927 9.2129C19.7654 8.34859 20.2788 7.58915 20.9327 6.93456C21.5866 6.27998 22.3488 5.76616 23.2193 5.3931C24.0897 5.01991 25.0158 4.83331 25.9975 4.83331C26.9929 4.83331 27.9228 5.0197 28.7872 5.39248C29.6516 5.76526 30.411 6.27859 31.0656 6.93248C31.7202 7.58637 32.234 8.34512 32.607 9.20873C32.9802 10.0722 33.1668 11.0017 33.1668 11.9973C33.1668 12.9788 32.9804 13.9053 32.6077 14.7766C32.2349 15.6479 31.7216 16.4108 31.0677 17.0654C30.4138 17.72 29.655 18.2338 28.7914 18.6069C27.9279 18.9801 26.9984 19.1666 26.0029 19.1666Z",
    fill: "#22C55E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewedRegistryIcon);
export default __webpack_public_path__ + "static/media/reviewed-registry-icon.45d3ca4677c2facc6f3f155393db6e08.svg";
export { ForwardRef as ReactComponent };